/** @jsx jsx */
import { jsx } from "theme-ui"
import { Flex } from "@theme-ui/components"

import { renderLineBreak } from "../helpers"

import Column from "../components/column"
import Container from "../components/container"
import CTA from "../components/cta"
// import Carousel from "../components/carousel"
import ProjectCard from "../components/project-card"
import { Link } from "gatsby"
import Row from "../components/row"
import Text from "../components/text"
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 3
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
const ProjectGalleryModule = ({
  bladePatternData,
  projectsData,
  customStyle,
  isSwipable= false,
  linkPrefix=""
}) => {
  
  const renderProjectsCards = () => {
    return bladePatternData.contentCards.map((project, idx) => (
      <Column
        size={[12, 12,isSwipable? 12: 4]}
        customStyle={{
          mb: theme => [theme.spacing.vertical.sm, 0],
          width:"433px"
        }}
        key={idx}
      >
        {project.ctaDestination ?  <a
          href={`${linkPrefix ? linkPrefix:"/projects"}/${project.ctaDestination.ctaDestination}`}
          // type="internal"
        >
          <ProjectCard
            key={idx}
            text={[project.title]}
            background={project.desktopImage.file.url}
            sx={{ ...customStyle }}
          />
        </a>: <ProjectCard
            key={idx}
            text={[project.title]}
            background={project.desktopImage.file.url}
            sx={{ ...customStyle }}
          />}
       
      </Column>
    ))
  }

  return (
    <div
      id={bladePatternData.anchorLink}
      sx={{
        py: theme => [
          theme.spacing.vertical.md,
          theme.spacing.vertical.md,
          theme.spacing.vertical.lg,
        ],
        backgroundColor: theme => theme.colors.backgrounds.primary,
      }}
    >
      <Container>
        <Row
          customStyle={{
            mb: theme => [
              theme.spacing.vertical.sm,
              theme.spacing.vertical.sm,
              0,
            ],
          }}
        >
          <Column
            size={[12, 12, 6]}
            customStyle={{
              mb: theme => [
                theme.spacing.vertical.sm,
                theme.spacing.vertical.sm,
                theme.spacing.vertical.md,
              ],
            }}
          >
            <Text type="h2">{renderLineBreak(bladePatternData.title)}</Text>
          </Column>
          <Column size={[12, 12, 6]}>
            <Flex
              sx={{
                justifyContent: ["flex-start", "flex-start", "flex-end"],
              }}
            >
              <div>
                {bladePatternData.ctaTitle ? (
                  <CTA
                    link={bladePatternData.ctaDestination || "/"}
                    type={"secondary"}
                    linkType="internal"
                  >
                    {bladePatternData.ctaTitle}
                  </CTA>
                ) : null}
              </div>
            </Flex>
          </Column>
        </Row>

        {/* <Row customStyle={{ display: ["block", "block", "none"] }}>
          <Carousel type="quaternary">{renderProjectsCards()}</Carousel>
        </Row> */}
        {isSwipable ? (
          <Carousel responsive={responsive} ssr={true} infinite={true}>
            {renderProjectsCards()}
          </Carousel>
        ) : (
          <Row customStyle={{ display: ["none", "none", "flex"] }}>
            {renderProjectsCards()}
          </Row>
        )}
      </Container>
    </div>
  )
}

export default ProjectGalleryModule
